<template>
  <div class="sign-main">
    <div class="sign_box">
      <div class="box_left">
        <img class="logo" src="@/assets/logo/logo.png" />
        <div class="title">
          AirDrop Management
          <div class="desc">Log in to view information about the TreasureNet AirDrop</div>
        </div>

        <div class="box_left_b">
          <!-- <div class="btn_tip">
            <span style="color: red">*</span>Please connect wallet:
          </div> -->
          <mmLogin ref="mmLogin" @success="getRoles"></mmLogin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mmLogin from "./mmLogin.vue";
import { getToken, setToken } from "@/utils/auth";
import { getAbi } from '@/api/file';
import Web3 from 'web3'
export default {
  components: {
    mmLogin,
  },
  data() {
    return {
      open: false,
      form: {
        address: undefined,
        signature: undefined,
        userID: undefined,
      },
      roleList: [],
      fms: process.env.VUE_APP_FMS,
      others: process.env.VUE_APP_OTHERS,
      TokenLockerAbi: [],
      contractAddress: '',
    };
  },
  computed: {},
  methods: {
    async getRoles(account) {
      console.log('getRoles', account)
      // setToken("")
      // let res = await getAbi('TokenLocker')
      // // console.log('res', JSON.stringify(res))
      // if (res.code === 0 && res.result) {
      //   this.contractAddress = res.result.address
      //   this.TokenLockerAbi = res.result.abi
      // } else {
      //   this.$refs.ErrorMsg.showErrorMsg('Failed to get contract info')
      //   return
      // }

      try {
        // 创建合约实例
        const web3 = window.ethereum ? new Web3(window.ethereum) : null
        if (!web3) {
          this.$message.error('Wallet not connected!')
          this.$refs.mmLogin.loginResult("error")
          return
        }
        console.log('this.TokenLockerAbi', this.TokenLockerAbi)
        console.log('this.contractAddress', this.contractAddress)
        const tokenLockerContract = new web3.eth.Contract(this.TokenLockerAbi, this.contractAddress)
        console.log('tokenLockerContract', tokenLockerContract)
        // 调用合约的checkManagerAccount方法判断是否为管理员
        const isManager = await tokenLockerContract.methods.checkManagerAccount(account).call()
        const isManager0x09eda46ffcec4656235391dd298875b82aa458a9 = await tokenLockerContract.methods.checkManagerAccount("0x09eda46ffcec4656235391dd298875b82aa458a9").call()
        console.log('isManager0x09eda46ffcec4656235391dd298875b82aa458a9', isManager0x09eda46ffcec4656235391dd298875b82aa458a9)
        console.log('isManager', isManager)
        if (isManager) {
          console.log('User is admin', account)
          this.$store.dispatch('SetRole', 1)
          this.$refs.mmLogin.loginResult("success")
          this.$router.push("/index")
        } else {
          this.$message.error('Not logged in with the specified account.Please switch to continue!')
          this.$refs.mmLogin.loginResult("error")
        }

        // else if (account && this.others.includes(account.toLowerCase())) {
        // 非管理员但在others列表中的用户
        //   console.log('User is in others list', account)
        //   this.$store.dispatch('SetRole', 2)
        //   this.$refs.mmLogin.loginResult("success")
        //   this.$router.push("/whitelistChangeProposal")
        // } 
      } catch (error) {
        console.error('Contract call failed:', error)
        this.$message.error('Contract call failed: ' + error.message)
        this.$refs.mmLogin.loginResult("error")
      }
    },
  },
  async created() {
    // // 在创建时获取合约信息
    // let res = await getAbi('TokenLocker')
    // if (res.code === 0 && res.result) {
    //   this.contractAddress = res.result.address
    //   this.TokenLockerAbi = res.result.abi
    // }
  },
  async mounted() {
    // const account = getToken()
    // if (!account) return
    //判断getroel

    const role = await this.$store.dispatch('GetRole')
    console.log('this.TokenLockerAbi', this.TokenLockerAbi)
    if (this.TokenLockerAbi.length === 0 || !this.contractAddress) {
      let res = await getAbi('TokenLocker')
      console.log('res', res)
      if (res.code === 0 && res.data) {
        this.contractAddress = res.data.address
        this.TokenLockerAbi = res.data.abi
      } else {
        console.log('Failed to get contract info')
      }
    }
    console.log('role', role)
    if (role) {
      this.$router.push("/index")
      return
    }


    // console.log('this.TokenLockerAbi', this.TokenLockerAbi)
    // console.log('this.contractAddress', this.contractAddress)
    // try {
    //   // 检查是否已经初始化web3环境
    //   const web3 = window.ethereum ? new Web3(window.ethereum) : null
    //   if (!web3) return

    //   const tokenLockerContract = new web3.eth.Contract(this.TokenLockerAbi, this.contractAddress)


    //   // 调用合约判断是否为管理员
    //   const isManager = await tokenLockerContract.methods.checkManagerAccount(account).call()
    //   console.log('isManager', isManager)
    //   if (isManager) {
    //     this.$store.dispatch('SetRole', 1)
    //     this.$router.push("/")
    //   } else if (account && this.others.includes(account.toLowerCase())) {
    //     this.$store.dispatch('SetRole', 2)
    //     this.$router.push("/whitelistChangeProposal")
    //   }
    // } catch (error) {
    //   console.error('合约调用失败:', error)
    // }
  },
  watch: {},
};
</script>
<style lang="scss">
.sign-main {
  width: 100%;
  height: 100%;
  background: url("~@/assets/image/login/big-bg2.png") no-repeat center center;
  background-size: cover;

  .sign_box {
    width: 10.52rem;
    // min-height: 4.44rem;
    margin: 0 auto;
    padding-top: 2.56rem;

    .logo {
      width: 1.43rem;
      padding-left: 0.32rem;
      padding-top: 0.28rem;
    }

    .title {
      height: 0.38rem;
      font-size: 0.32rem;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
      line-height: 0.38rem;
      margin-top: 0.44rem;
      margin-bottom: 0.48rem;
      text-align: center;
    }

    .desc {
      font-size: 0.18rem;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 0.24rem;
    }
    .box_left{
      padding: 0.3rem 0.4rem;
      border-radius: 0.11rem;
    }
    .box_left.active {
      float: left;
    }

    .box_left,
    .box_right {
      width: 6rem;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(253, 252, 253, 0.5);
      // box-shadow: 0px 0px 10px 1px rgb(255 255 255 / 50%);
      box-sizing: border-box;
      margin: 0 auto;

      .box_left_b,
      .box_list {
        // background: #f7f8fa;
        padding: 0.24rem 0.32rem;
      }
    }
  }
}

.box_left_b {
  // padding-bottom: 0.8rem !important;

  .btn_tip {
    height: 0.28rem;
    font-size: 0.18rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
    margin-bottom: 0.1rem;
  }

  .foot_tip {
    font-size: 0.16rem;
    font-family: DMSans-Regular, DMSans;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 0.24rem;
    margin-top: 0.64rem;
    padding: 0 0.16rem;
  }
}

.box_list {
  .tip {
    font-size: 0.18rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
  }

  .listItem {
    height: 0.56rem;
    background: #ffffff;
    border-radius: 0.12rem;
    border: 2px solid #d9dde3;
    cursor: pointer;
    font-size: 0.18rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #333333;
    line-height: 0.56rem;
    margin-top: 0.12rem;
    padding: 0 0.16rem;
    display: flex;
    justify-content: space-between;
  }

  .btn {
    margin-top: 0.46rem;
    text-align: center;

    .icon_back {
      width: 0.16rem;
    }
  }
}
</style>
